import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AiFillFacebook, AiFillTwitterSquare } from "react-icons/ai";
import { TravelGuideResType } from "../../types/global";
import GuideArticleListCard from "../cards/GuideArticleListCard";
import NavBelt from "../page-essentials/NavBelt";
import { travelGuideBreadCrumpData } from "../static-data/breadcrump";
import LangContext from "../../context/LangContext";
import ShareButtons from "../page-essentials/ShareButtons";

const TravelGuide = () => {
  const [data, setData] = useState<TravelGuideResType[]>([]);
  const [singleTravelGuide, setSingleTravelGuide] =
    useState<TravelGuideResType>();

  const { lang_id } = useContext(LangContext);

  const filterSingleTravelGuide = (id: string) => {
    const [travel_guide] = data.filter((item) => item.id === id);
    setSingleTravelGuide(travel_guide);
  };

  const fetchTravelGuideList = async (lang_id: string) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/travelGuide/getAll?lang=${lang_id}`
      );
      setData(res.data.data);
      setSingleTravelGuide(res.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (lang_id) {
      fetchTravelGuideList(lang_id);
    }
  }, [lang_id]);
  return (
    <div>
      <NavBelt
        img="https://images.unsplash.com/photo-1618083840944-31cc42fcf250?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        breadCrumpInfo={travelGuideBreadCrumpData}
        page="Travel Guide"
      />
      <div className="container mx-auto px-4 2xl:px-8 lg:grid grid-cols-12 gap-8 my-16">
        {/* <TestReponsive /> */}

        <div className="md:col-span-7 lg:col-span-8 ">
          <div className="prose lg:prose-lg 2xl:prose-xl lg:prose-h1:leading-normal prose-p:text-justify prose-p:leading-loose  w-full max-w-full lg:pr-4">
            {singleTravelGuide ? (
              <>
                <h1 className="prose">
                  {singleTravelGuide?.travel_guide_title}
                </h1>

                <article
                  dangerouslySetInnerHTML={{
                    __html: singleTravelGuide?.travel_guide_description!,
                  }}
                ></article>
              </>
            ) : (
              ""
            )}
          </div>
          <hr className="my-4" />
          <div className="text-lg font-medium">Share this travel guide : </div>
          <ShareButtons />
        </div>
        {/* right side of main grid  */}
        <div className="md:col-span-5 lg:col-span-4 relative ">
          <div className="lg:max-h-[90vh] lg:overflow-y-auto lg:no-scrollbar lg:sticky top-24">
            <div className="flex items-center justify-between mt-8 lg:mt-0">
              <h1 className="font-semibold text-lg">Trave Guide Articles</h1>
              <p className="text-gray-500">{data.length} Results</p>
            </div>
            <form action="" className="hidden lg:block">
              <input
                type="text"
                name=""
                placeholder="Search ..... "
                id=""
                className="focus:border-primary-base rounded-md w-full mt-4 focus:ring-primary-base outline-primary-base"
              />
            </form>

            <div className="bg-gray-100 p-2 lg:p-4 shadow rounded-md mt-8 grid lg:block md:grid-cols-2 gap-8">
              {data.map((item) => (
                <div key={item.id}>
                  <GuideArticleListCard
                    data={item}
                    handleReadMore={() => filterSingleTravelGuide(item.id)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelGuide;
